import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class WorkOrderIssueService {
  getAll(organizationId: string, propertyId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/${organizationId}/${propertyId}/issues`, options);
  }
}

export default WorkOrderIssueService;
